import React from "react";

const download_app_links = (props) => {

    return (
        <div className={props.classes}>
            {props.google_play_link &&
                <a
                    href={props.google_play_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="stores-link stores-link-google"
                >
                    google playstore
                </a>
            }
            {props.app_store_link &&
                <a
                    href={props.app_store_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="stores-link stores-link-apple"
                >
                    apple store
                </a>
            }
            {props.huawei_store_link &&
                <a
                    href={props.huawei_store_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="stores-link stores-link-huawei"
                >
                    huawei store
                </a>
            }
            { props.children}
        </div >
    );
}

export default download_app_links;